import styled from 'styled-components';
import { COLOR_WHITE, COLOR_ORANGE } from '../../../../assets/styles/colors';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../../assets/styles/breakpoints';

export const TableSellTypeSC = styled.div`
  min-width: 460px;
  padding: 12px;
  border-radius: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background: white;

  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    min-width: auto;
  }

  @media (max-width: 450px) {
    flex-direction: column;

    .selector-text {
      margin-bottom: 10px;
    }
  }

  .tab-wrapper {
    display: flex;
    /* height: 43px; */
    width: 250px;
    border: solid 1px transparent;
    border-radius: 7px;
    background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(-90deg, #fab535, #f7931e);
    background-origin: border-box;
    background-clip: content-box, border-box;

    button {
      border-radius: 6px;
      padding: 4px 16px 4px 16px;
      font-size: 14px;
      /* line-height: 21px; */
      border: none;
      background: none;
      background-image: transparent;
      color: ${COLOR_ORANGE};
      font-weight: bold;
      flex: 1;

      &.active {
        background-image: linear-gradient(-90deg, #fab535, #f7931e);
        color: ${COLOR_WHITE};
        box-shadow: 0 4px 15px 0 rgba(47, 46, 65, 0.15);
        margin-top: -1px;
        /* height: 25px; */
      }

      &.disabled {
        opacity: 0.5;
      }
    }
  }
`;
